// John Eldhose 20180518
import { RestfulPost } from './Restful';

export async function login(username, password, remember) {
  let data = {
    username: username,
    password: password,
    remember: remember
  };
  const Auth = await RestfulPost('login', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return Auth;
}



// WEBPACK FOOTER //
// ./src/Api/login.js